// extracted by mini-css-extract-plugin
export default {"orderPageErrorContainer":"fetchError_orderPageErrorContainer__9PtIT","returnButtonWrap":"fetchError_returnButtonWrap__6CqSb","returnButton":"fetchError_returnButton__sKiT7"};